import React, { useEffect, useState } from 'react';
import { getCreatedPermissions } from 'api';
import { MessageDetailsDialog } from 'components';
import { NoData } from 'components/NoData';
import useNetwork from 'hooks/use-network';
import useData, { PROVIDERS } from 'hooks/useData';
import { useWalletProvider } from 'hooks/useWalletProvider';
import { isEmpty } from 'lodash';
import { useCurrentSafe, usePermissionList } from 'store';
import { IMultisigTransaction } from 'utils/transform-multisig-transaction';

import { MessageView } from './components/message-view';

type Props = {
  transactionsHistory?: IMultisigTransaction[];
};

// TODO_Y: [PN]
// TODO_R: [RCC]
export const Messages = ({ transactionsHistory }: Props) => {
  const { signPermissionsMessage } = useData();
  const { currentSafe } = useCurrentSafe();

  const [network] = useNetwork();
  const [messageTransaction, setMessageTransaction] = useState<string>('');
  const { permissionList, setPermissionList, setIsLoading } = usePermissionList();
  const walletProvider = useWalletProvider();

  const fetchPermissions = async () => {
    setIsLoading(true);
    getCreatedPermissions(currentSafe.address, `stx:${network}`)
      .then((res) => {
        setPermissionList(res);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchPermissions().then();
  }, []);

  const onSign = (message: string) => {
    signPermissionsMessage(
      currentSafe.address,
      message,
      walletProvider?.provider as PROVIDERS,
      fetchPermissions
    );
  };

  if (isEmpty(permissionList)) return <NoData />;

  return (
    <>
      <div className="hidden sm:grid grid-cols-[35%_20%_20%_15%_10%] px-32 my-16 text-m13 text-[#949494] font-semibold">
        <span>Message</span>
        <span>Initiator address</span>
        <span>Threshold</span>
        <span>Status</span>
        <span></span>
      </div>
      {permissionList.reverse().map((message) => (
        <div
          key={message._id}
          onClick={(e) => {
            e.stopPropagation();
            setMessageTransaction(message._id);
          }}
          data-id={message._id}
        >
          <div className="z-0">
            <MessageView messageToSign={message} onSign={onSign} />
            <hr className="mx-20 sm:mx-32 border-t border-black-4" />
          </div>
        </div>
      ))}
      {Boolean(messageTransaction) && (
        <MessageDetailsDialog
          messageId={messageTransaction}
          onClose={() => {
            setMessageTransaction('');
          }}
          onSign={onSign}
        />
      )}
    </>
  );
};
